import { CSSProperties } from "react";

import { ClassNameFormatter } from "@bem-react/classname";
import { getFormTags } from "@multiweb/forms";
import { bridge } from "@multiweb/reactCore/bridge";
import { bemClassNames, CUSTOM_CSS_PROPERTY_PREFIX, transformKeysToParamCase } from "@multiweb/reactUtils";
import { StretchType } from "UI/UI/UI/Controls/ControlEnums";
import { BaseAlignElement } from "UI/UI/UI/XGControls/AlignPanels/BaseAlignElement";
import { GeneralItemRenderer } from "../GeneralItemRenderer";
import { ClassNamesModifiersType } from "../types";

const { getState } = bridge;

const classNames = bemClassNames("groupbox-item-renderer");

export class GroupBoxItemRenderer extends GeneralItemRenderer {
    private _asCard: boolean;

    /** Určuje, zda se má element vyrenderovat jako karta. */
    public get asCard(): boolean {
        if (this._asCard === undefined) {
            const formTags = getFormTags(getState(), this.ownerForm.element.id);
            this._asCard = !!formTags?.["ExtraStyleClass-group-box--card"];
        }
        return this._asCard;
    }

    public override get classNameModifiers(): ClassNamesModifiersType {
        return {
            ...super.classNameModifiers,
            "as-card": this.asCard,
        };
    }

    public override get styles(): CSSProperties {
        const height = this._styleInnerElementHeight();
        return {
            ...super.styles,
            ...transformKeysToParamCase(
                {
                    thisHeight: this.asCard ? (typeof height === "number" ? `${height}px` : height) : undefined,
                },
                CUSTOM_CSS_PROPERTY_PREFIX,
            ),
        };
    }

    /**
     * Pokud se má groupbox vyrenderovat jako karta, tak potřebuju dostat výšku z definice
     * do css proměnné. Tato metoda získá její hodnotu.
     */
    private _styleInnerElementHeight(): number | string | undefined {
        if (this.asCard) {
            const dataStretch = BaseAlignElement.parseStretchType(this.innerElement.getAttribute("data-stretch"));
            if (dataStretch === StretchType.vertical || dataStretch === StretchType.both || !super.innerElementHeight) {
                return "100%";
            }
            return super.innerElementHeight;
        }
        return undefined;
    }

    public override get innerElementHeight(): number | string | undefined {
        if (this.asCard) {
            return undefined;
        }
        return super.innerElementHeight;
    }

    public override get classNames(): ClassNameFormatter {
        return classNames;
    }
}
